// extracted by mini-css-extract-plugin
module.exports = {"homeContent":"dp-OPj0Rrct","desc":"dp-O5s8mt7a"};